'use client';

import { useEffect } from 'react';
import useSyncedRef from 'src/hooks/utils/useSyncedRef';

export default function useInterval(
	callback: () => void,
	delayMs: number | null,
	runOnCallbackChange = false
) {
	const savedCallback = useSyncedRef(callback);

	// Execute callback on change if specified.
	useEffect(() => {
		if (runOnCallbackChange) {
			savedCallback.current();
		}
	}, [callback, runOnCallbackChange]);

	// Set up the interval.
	useEffect(() => {
		function tick() {
			savedCallback.current();
		}

		if (delayMs !== null) {
			tick();

			const id = setInterval(tick, delayMs);
			return () => {
				clearInterval(id);
			};
		}
	}, [delayMs]);
}
